import useReceiveLoginHint from "hooks/useReceiveLoginHint";

// 네이티브가 OneLink로 보내는 1회성 "lastLoginMethod" 푸시는 앱 부팅 직후 발사되므로,
// 로그인 화면 전용으로 받으면 그 시점에 리스너가 없어 유실된다.
// 어느 화면에서든 받도록 상시 마운트되는 전용 리시버(loginHintAtom에 저장). UI 없음.
export default function LoginHintReceiver() {
  useReceiveLoginHint();
  return null;
}
